import { AudioEngine } from '../audio/engine';
import type { CommandTool, GameState } from '../state/types';
import type { SceneContext } from '../scene/setup';
import { createFloatingIndicator } from '../ui/floatingLabel';
import { updateHTML_UI } from '../ui/sidebar';

export function setCommandTool(state: GameState, tool: CommandTool, refreshUi: () => void): void {
  state.selectedTool = tool;
  refreshUi();
}

export function dispatchManualCommand(
  state: GameState,
  ctx: SceneContext,
  fieldId: number,
  forceUnit: CommandTool | null = null,
): void {
  if (state.phase !== 'playing') return;

  const field = state.fields.find((f) => f.id === fieldId);
  if (!field) return;

  let targetUnit: CommandTool = forceUnit || state.selectedTool;

  if (targetUnit === 'auto') {
    targetUnit = field.ndviRemaining <= 0 ? 'drone' : 'truck';
  }

  if (targetUnit === 'drone') {
    if (
      state.drone.targetFieldId === fieldId &&
      (state.drone.state === 'Moving' || state.drone.state === 'Working')
    ) {
      createFloatingIndicator(ctx, '🚁 Drón már ezen a parcellán van!', field.x, field.z, true);
      AudioEngine.playBeep(220, 'sawtooth', 0.25);
    } else {
      state.drone.state = 'Moving';
      state.drone.targetFieldId = fieldId;
      state.drone.task = 'Scan';
      state.drone.progress = 0;
      createFloatingIndicator(ctx, '🚁 Drón kirendelve: Felmérés', field.x, field.z);
      AudioEngine.playBeep(659, 'sine', 0.15);
    }
  } else if (targetUnit === 'truck') {
    if (
      state.truck.targetFieldId === fieldId &&
      (state.truck.state === 'Moving' || state.truck.state === 'Working')
    ) {
      createFloatingIndicator(ctx, '🚗 Pickup már ezen a parcellán van!', field.x, field.z, true);
      AudioEngine.playBeep(220, 'sawtooth', 0.25);
    } else {
      state.truck.state = 'Moving';
      state.truck.targetFieldId = fieldId;
      state.truck.task = 'Treat';
      state.truck.progress = 0;
      createFloatingIndicator(ctx, '🚗 Pickup kirendelve: Permetezés', field.x, field.z);
      AudioEngine.playBeep(493, 'sine', 0.15);
    }
  }
  updateHTML_UI(state, (id, unit) => dispatchManualCommand(state, ctx, id, unit ?? null));
}
